import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import TableCasino from './block/table';
import {ReactComponent as ArrowRight} from '../../../../../@casino/img/right-arrow.svg';
import {ReactComponent as ArrowDown} from '../../../../../@casino/img/down-arrow.svg';
import {columns, useStyles, getRows} from './helpers';
import { setGetUserLogger } from '../../store/thunk/setGetUserLogger';

const BlockHistorySignIn = ({id}) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const [rezyme, setRezyme] = React.useState(false);

    React.useEffect(() => {
        if (rezyme) {
            dispatch(setGetUserLogger({
                id,
                page: 1,
                rowsPerPage: 5
            }))
        }
    }, [id, rezyme])

    const rezymeArr = useSelector(state => state.users.user_logger);
    const rows = React.useMemo(() => getRows(rezymeArr.data), [rezymeArr]);
    
    return (
        <div>
            <div 
                className={classes.wrapTitle}
                onClick={() => {
                    setRezyme(!rezyme)
                }}
            >
                <span
                    className={classes.title}
                >
                    История входов
                </span>
                {
                    !rezyme && 
                    <ArrowRight className={classes.arrow}/>
                }
                {
                    rezyme && 
                    <ArrowDown className={classes.arrow}/> 
                }   
            </div>
            <div>
                {
                    rezyme && id &&
                    <TableCasino 
                        allPage={rezymeArr.count}
                        pagination
                        width={1280}
                        perPage={5}
                        columns={columns}
                        rows={rows}
                        changePage={(v) => dispatch(setGetUserLogger({
                            page: 1,
                            rowsPerPage: v.rowsPerPage,
                            id
                        }))}
                        changeRowsPerPage={(v) => dispatch(setGetUserLogger({
                            page: 1,
                            rowsPerPage: v.rowsPerPage,
                            id
                        }))}
                    /> 
                }
            </div>       
        </div>
    )
}

export default BlockHistorySignIn;